import request from '@/utils/request'

// 登录方法
// export function login(username, password, code, uuid) {
//     password = encrypt(password)
//     const data = {
//         username,
//         password,
//         code,
//         uuid
//     }
//     return request({
//         url: '/auth/login',
//         method: 'post',
//         data: data
//     })
// }

// // 获取用户详细信息
// export function getInfo() {
//     return request({
//         url: '/system/user/getInfo',
//         method: 'get'
//     })
// }

export function loginPhoneCode(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/phoneCode',
        method: 'get',
        params: query
    })
}


//跳转第三方应用 获取code
export function clientAutoLoginCode(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/menHuCode',
        method: 'get',
        params: params
    })
}


/**登录三步走 start*/
//获取code
export function registeredClientCode(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/code',
        method: 'get',
        params: params
    })
}
//角色登录获取code
export function registeredClientRoleCode(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/code3',
        method: 'post',
        data: data
    })
}
//根据codeValue获取到用户的accessToken与freshToken
export function getAccessTokenByCodeValue(data) {
    return request({
        url: '/oauth/server-exam/authorization/gettoken',
        method: 'post',
        data: data
    })
}
// 选择角色登录，直接换取凭证
export function refreshTokenByRelogin(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/refreshTokenByRelogin',
        method: 'post',
        data: data
    })
}
// 根据code获取用户openid
export function getOpenIdByCode(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/checkOfficialAccountLoginStatus',
        method: 'get',
        params: params
    })
}
// 根据手机号获取登录用户列表
export function getUsersByTel(params) {
    return request({
        url: '/oauth/server-audit/userAudit/getUserInfoByTel',
        method: 'get',
        params: params
    })
}
// 切换用户
export function changeUser(data) {
    return request({
        url: '/oauth/server-exam/authorization/getTokenByUserNameAndPhoneNumber',
        method: 'post',
        data: data
    })
}
// 获取用户详细信息
export function getInfoByAnthor(data) {
    return request({
        url: '/oauth/server-exam/authorization/checktoken',
        method: 'post',
        data: data
    })
}
/**登录三步走 end*/
// 退出方法
export function logout() {
    return request({
        url: '/auth/logout',
        method: 'delete'
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/code',
        method: 'get'
    })
}

// 刷新方法
export function refreshToken() {
    return request({
        url: '/auth/refresh',
        method: 'post'
    })
}

// 获取用户列表
export function userList(params) {
    return request({
        url: '/oauth/server-exam/registeredClient/Userlist',
        method: 'get',
        params: params
    })
}
// 获取用户列表
export function automatically(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/automatically',
        method: 'post',
        data: data
    })
}
export function associations(data) {
    return request({
        url: '/oauth/server-exam/registeredClient/associations',
        method: 'post',
        data: data
    })
}


// 根据不同登录类型获取code并跳转地址
export function getCodeUrl(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/code',
        method: 'get',
        params: query,
        // baseUrl:'/dev-api-new'
    })
}

//获取手机验证码
export function getPhoneCode(query) {
    return request({
        url: '/oauth/server-exam/registeredClient/phoneCode',
        method: 'get',
        params: query,

    })
}

// 根据手机号查询注册状态（新增接口）
export function getPhoneNumberRegisterStatus(query) {
    return request({
        url: '/oauth/server-audit/userAudit/getPhoneNumberRegisterStatus',
        method: 'get',
        params: query,

    })
}

//忘记密码获取手机验证码
export function getforgetPWCode(query) {
    return request({
        url: '/oauth/server-audit/userAudit/forgetPWCode',
        method: 'get',
        params: query,

    })
}

export function sendAppUsedRecord(clientId) {
    return request({
        url: `/oauth/chart/client/record/${clientId}`,
        method: 'put'
    })
}
export function getCodeByToken(data) {
    return request({
        url: '/oauth/server-exam/authorization/getCodeByToken',
        method: 'post',
        data
    })
}
export function getLongCodeByToken(data) {
    return request({
        url: '/oauth/server-exam/authorization/longCode',
        method: 'post',
        data
    })
}

export function resetPwd(data) {
    return request({
        url: '/oauth/server-audit/userAudit/resetPwd',
        method: 'put',
        data: data
    })
}

// 校验用户信息与账号是否匹配
export function verifyUserData(params) {
    return request({
        url: '/oauth/server-audit/userAudit/verifyUserData',
        method: 'get',
        params: params
    })
}

// 资料辅助方式重置密码
export function resetPwdByData(data) {
    return request({
        url: '/oauth/server-audit/userAudit/resetPwdByData',
        method: 'put',
        data: data
    })
}

// 获取用户是否在3个月内修改过密码
export function getUserEditPwd() {
    return request({
        url: '/oauth/server-oauth/userbase/editPwd',
        method: 'get'
    })
}

// 记录用户已经修改过密码
export function setUserEditPwd() {
    return request({
        url: '/oauth/server-oauth/userbase/editPwd',
        method: 'put'
    })
}